module.exports = __webpack_public_path__ + "static/media/mangal-regular.818358a8.woff2";